import React from "react"

const IconButton = ({ icon, className, imgClassName, ...rest }) => {
  return (
    <button
      className={`inline-flex items-center justify-center bg-primary w-8 h-8 sm:w-12 sm:h-12 rounded-full shadow-icon-button ${className} disabled:opacity-75 disabled:cursor-not-allowed disabled:bg-disabled `}
      {...rest}>
      <img src={icon} alt="" className={imgClassName} />
    </button>
  )
}

export default IconButton
